import {
    FormDefinitionFieldSubType, FormDefinitionFieldSummaryModel,
    FormDefinitionFieldType
} from "../../../../modules/form/definition/field/api/entity/formDefinitionFieldSummary.model";
import {FieldInputTypeHandlerRegister} from "./type-handler/IFieldInputTypeHandler";
import {
    AbstractFieldInputTypeHandlerComponent,
    FormValueReadableValue
} from "./type-handler/abstract-field-input-type-handler.component";
import {FormDefinitionFieldModel} from "../../../../modules/form/definition/field/api/entity/formDefinitionField.model";
import {
    FormFieldDefinitionOptionModel
} from "../../../../modules/form/definition/field/api/entity/formFieldDefinitionOption.model";

export class FieldDefinitionUtils {

    public static resolveReadableValuesFromDefinition(value: any, fieldDefinition: FormDefinitionFieldModel): Promise<FormValueReadableValue[]> {
        return FieldDefinitionUtils.resolveReadableValues(value,
            fieldDefinition.summary.type.value,
            fieldDefinition.summary.subType?.value,
            fieldDefinition.unit,
            fieldDefinition.options);
    }

    public static resolveReadableValues(value: any, typeValue: string,
                                        subTypeValue: string,
                                        unit: string,
                                        options: FormFieldDefinitionOptionModel[]): Promise<FormValueReadableValue[]> {
        if (!value && value != 0) {
            return Promise.resolve([]);
        }

        console.log('resolveReadableValues', typeValue, subTypeValue);
        if (FieldDefinitionUtils.isCustom(typeValue, subTypeValue)) {
            const handler = FieldInputTypeHandlerRegister.getImplementation(typeValue,
                subTypeValue);
            if (!handler) {
                console.error('No handler found for type "' + typeValue + '" and subType "' + subTypeValue + '"');
                return Promise.resolve([FormValueReadableValue.ofText('Une erreur est survenue')]);
            }
            console.log(['handler', handler]);
            return (handler as unknown as typeof AbstractFieldInputTypeHandlerComponent<any>).resolveReadableValues(value, unit, options);
        }

        let values: FormValueReadableValue[] = [];
        if(typeValue === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_NUMERIC) {
            values = [FormValueReadableValue.ofText(FieldDefinitionUtils.formatValue(value, unit))];
        } else if (typeValue === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_CHOICE) {
            if (!subTypeValue) {
                let val = '?';
                const selectedOption = options.find(option => option.value == value);
                if (selectedOption) {
                    val = selectedOption.label;
                }
                values = [FormValueReadableValue.ofText(val)];
            }
        } else if (typeValue === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_YES_NO) {
            values = [FormValueReadableValue.ofText(value === true ? 'Oui' : 'Non')]
        } else if (typeValue === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_NEGATIVE_POSITIVE) {
            values = [FormValueReadableValue.ofText(value === true ? 'Positif' : 'Négatif')]
        } else if (typeValue === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_TEXT) {
            values = [FormValueReadableValue.ofText(value)];
        } else if (typeValue === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_RICH_TEXT) {
            values = [FormValueReadableValue.ofText(value)];
        } else {
            values = [FormValueReadableValue.ofText(value)];
        }
        return Promise.resolve(values);
    }

    private static formatValue(value: string, unit: string){
        if (! unit){
            return value;
        }
        return value + unit;
    }

    public static isCustom(typeValue: string, subTypeValue: string): boolean {
        if (typeValue === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_JSON
            || typeValue=== FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_EMBEDDED_FILE
            || typeValue === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_DOCUMENT) {
            return true;
        }
        if (subTypeValue === FormDefinitionFieldSubType.FORM_DEFINITION_FIELD_SUBTYPE_SELECT_MANY
            && typeValue === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_CHOICE) {
            return true;
        }
        return typeValue === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_DRAWABLE_IMAGE
            || typeValue === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_DRAWABLE_IMAGE_V2
            || typeValue === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_VIDEO_ANALYSIS;
    }
}